module.exports = __webpack_public_path__ + "static/media/YM50_1.894d22a8.jpg";